


























































import { computed, defineComponent, ref } from '@vue/composition-api';

import axios from 'axios';
import { snackbar } from '@/components/GlobalSnackbar';
import UserPassword from '@/components/UserPassword.vue';
import { SERVER_URL, MPF_ABOUT_URL } from '@/environment';

export default defineComponent({
  name: 'Login',
  components: { UserPassword },
  setup(props, ctx) {
    // NOTE: May need to be computed ref
    const router = ctx.root.$router;

    const username = ref<string>('');
    const email = ref<string>('');
    const password = ref<string>('');
    const confirmPassword = ref<string>('');
    const validPassword = computed(() => password.value && password.value === confirmPassword.value);
    const emailValid = computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()));
    const formValid = computed(() => username.value.trim() && emailValid.value && validPassword.value);
    const loginErrorMessage = ref<string>('');
    const emailErrorMessage = ref<string>('');

    function reset() {
      username.value = '';
      email.value = '';
      password.value = '';
      confirmPassword.value = '';
      loginErrorMessage.value = '';
      emailErrorMessage.value = '';
    }

    const updatePW = (val: string) => {
      password.value = val;
    };
    const updateCPW = (val: string) => {
      confirmPassword.value = val;
    };

    function accountCreated(registeredEmail: string) {
      // Reset form
      reset();

      // Display notification
      snackbar.dispatch({
        text: 'Verification email sent. Open the link in your email to activate your account.',
        timeout: 3000,
        options: {
          color: 'success',
          top: true,
          immediate: true,
        },
      });

      // Pending accounts use the same verification and resend workflow as
      // existing unverified accounts.
      router.push({ path: '/email-verification', query: { email: registeredEmail, sent: '1' } });
    }

    async function createUser() {
      if (!formValid.value) {
        return;
      }

      try {
        const registeredEmail = email.value.trim().toLowerCase();
        const response = await axios.post(`${SERVER_URL}/auth/selfRegister`, {
          username: username.value,
          password: password.value,
          email: registeredEmail,
        });
        window.sessionStorage.setItem(
          'painfacePendingEmailChangeToken',
          response.data.pending_email_change_token,
        );
        accountCreated(registeredEmail);
      } catch (error) {
        const response = (error as { response?: { data?: string } }).response;
        const message = typeof response?.data === 'string'
          ? response.data
          : 'Unable to create account. Please try again.';
        if (message.toLowerCase().includes('email')) {
          emailErrorMessage.value = message;
        } else {
          loginErrorMessage.value = message;
        }
      }
    }

    return {
      SERVER_URL,
      MPF_ABOUT_URL,
      createUser,
      loginErrorMessage,
      username,
      email,
      emailErrorMessage,
      formValid,
      UserPassword,
      updatePW,
      updateCPW,
    };
  },
});
